<mat-card>
  <mat-card-header>
    <mat-card-title i18n>Page not found</mat-card-title>
    <mat-card-subtitle>=(</mat-card-subtitle>
  </mat-card-header>
</mat-card>
